import DomainPromo from './DomainPromo';

export default DomainPromo;
